// custom-slider.js
$(document).ready(function () {
  $('.custom-slideshow-slider').slick({
    slidesToShow: 1, 
    slidesToScroll: 1, 
    autoplay: false, 
    // autoplaySpeed: 5000, 
    arrows: false, 
    dots: true, 
  });
});
// $('.magic-validation').click(function () {
//    $(this).parents('.magin-code-v1-box').find('span.error').hide();
  
//   var magic=$('input.your-code').val();
//   if(magic.length > 5){
//     var magic_codes=$('.magic_codes').val();
//     if(magic_codes.indexOf(magic) !== -1){
//       var next=$(this).data('next');
//       $('.magic-code').hide();
//       $('.magic-code-v2').show();
//       $('.magic-placeholder').val(magic);
//     }else{
//      $(this).parents('.magin-code-v1-box').find('span.error').show();
//     }
//   }else{
//      $(this).parents('.magin-code-v1-box').find('span.error').show();
    
//   }
// });
$('.magic-code-continue').click(function () {
  $('.magic-code').hide();
  $('.magic-code-v3').show();
})